import { IconButton } from '@mui/material';
import { styled } from '~/themes';
import SearchIcon from '~/assets/images/icons/search-line.svg';

type SearchPrefixProps = {};

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  'width': theme.spacing(2.2),
  'height': theme.spacing(2.2),
  'marginRight': theme.spacing(-0.9),
  '& > img': {
    width: 16,
    height: 16,
  },
}));

export const SearchInputPrefix: React.FC<SearchPrefixProps> = () => (
  <StyledIconButton size='large'>
    <img alt='search-icon' src={SearchIcon} width={22} height={22} />
  </StyledIconButton>
);
